import { createStore, Store, useStore as baseUseStore } from 'vuex'
import { InjectionKey } from 'vue'
import {Game} from "@/data/Game";
import {Environment} from "@/data/Environment";
import {TestingParameters} from "@/data/TestingParameters";
import {Integration} from "@/data/Integration";
import {Language} from "@/data/Language";
// define your typings for the store state
export interface State {
  version: string;
  games: Game[]
  environments: Environment[]
  integrations: Integration[]
  languages: Language[]
  currencies: string[]
  playModes: string[]
  buildPrefixes: string[]
  parameters: TestingParameters
  local: boolean
  mock: boolean;
  prototype: boolean
}

// define injection key
export const key: InjectionKey<Store<State>> = Symbol()

export const store = createStore<State>({
  state: {
    version: process.env.APP_VERSION,
    games: [],
    environments: [],
    integrations: [],
    languages: [],
    currencies: [],
    playModes: [],
    buildPrefixes: [],
    parameters: null,
    local: false,
    prototype: false,
    mock: false,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})

export function useStore (): Store<State> {
  return baseUseStore(key)
}
